import React from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import moment from "moment";
import { Card, CardTitle, CardText } from "material-ui";
import { StyleSheet, css } from "aphrodite";

const RoomRate = (rate, index) => (
  <div key={index}>
    <span className={css(styles.roomRate)} key={index}>
      {rate}
    </span>
    <br />
  </div>
);

const Amenity = (amenity, index) => <li key={index}>{amenity}</li>;

@connect((state) => ({
  departure: state.RateQuote.get("departure"),
  dateString: state.RateQuote.get("dateString"),
  destination: state.RateQuote.get("destination"),
  vendorName: state.RateQuote.get("vendorName"),
  vendorURL: state.RateQuote.get("vendorURL"),
  rateType: state.RateQuote.get("rateType"),
  deposit: state.RateQuote.get("deposit"),
  cancellation: state.RateQuote.get("cancellation"),
  roomRates: state.RateQuote.get("roomRates"),
  amenities: state.RateQuote.get("amenities"),
  amenityType: state.RateQuote.get("amenityType"),
  averageRate: state.RateQuote.get("averageRate"),
}))
export default class RateQuote extends React.Component {
  static propTypes = {
    className: PropTypes.string.isRequired,
    departure: PropTypes.number,
    dateString: PropTypes.string,
    destination: PropTypes.string.isRequired,
    vendorName: PropTypes.string.isRequired,
    vendorURL: PropTypes.string.isRequired,
    rateType: PropTypes.string,
    deposit: PropTypes.string,
    cancellation: PropTypes.string,
    roomRates: PropTypes.string.isRequired,
    amenities: PropTypes.string.isRequired,
    amenityType: PropTypes.string.isRequired,
    averageRate: PropTypes.string,
  };

  static defaultProps = {
    departure: null,
    dateString: "",
  };

  vendorDisplay = () => {
    const { vendorName, vendorURL } = this.props;
    if (vendorURL) {
      return (
        <a href={vendorURL} className={css(styles.vendorLink)}>
          {vendorName}
        </a>
      );
    }
    return vendorName;
  };

  render() {
    const { className } = this.props;
    const departure = moment(this.props.departure)
      .format("DDMMM")
      .toUpperCase();

    return (
      <Card className={className}>
        <CardTitle title="Formatted Rate Quote" />
        <CardText className={css(styles.rateQuote)}>
          <p>
            <b>
              {this.props.dateString} (departing {departure}) -{" "}
              {this.props.destination}
            </b>
          </p>
          <p>
            <b>{this.vendorDisplay()}</b>
          </p>
          <p className={css(styles.rateInfo)}>
            {this.props.rateType} - {this.props.deposit}{" "}
            {this.props.cancellation}{" "}
            <i>
              In addition to any applicable hotel cancellation policies, we
              charge a 50 USD cancelation fee per reservation. Please refer to
              our{" "}
              <a href="https://www.ourismantravel.com/booking-policies/">
                booking policies
              </a>{" "}
              for full details.
            </i>
            {this.props.averageRate ? "Average nightly rates shown below exclude taxes and fees." : ""}
          </p>
          {this.props.roomRates.split("\n").map(RoomRate)}
          <p>
            <b>{this.props.amenityType} Amenities:</b>
          </p>
          <ul>{this.props.amenities.split("\n").map(Amenity)}</ul>
        </CardText>
      </Card>
    );
  }
}

const styles = StyleSheet.create({
  rateQuote: {
    fontFamily: "arial, sans-serif",
    fontSize: 12.8,
  },
  roomRate: {
    WebkitMarginAfter: 0,
    WebkitMarginBefore: 0,
  },
  rateInfo: {
    fontStyle: "italic",
  },
  vendorLink: {
    textDecoration: "underline",
  },
});



// WEBPACK FOOTER //
// /src/components/RateQuoteGenerator/RateQuote.js